import { useTranslation } from 'next-i18next'
import type { ReactElement } from 'react'
import { ButtonLabel } from '@pylot-data/hooks/product/utils/pdpProductLabels'
import cn from 'classnames'
import s from './Stockinfo.module.scss'

type ProductStockStatusProps = {
    stockStatus: string
    className?: string
}
export const ProductStockInfo = ({
    stockStatus,
    className
}: ProductStockStatusProps): ReactElement => {
    const { t } = useTranslation(['common'])
    return (
        <div
            className={cn(
                s['stock-info'],
                className && s[className],
                'stock-info'
            )}
        >
            {stockStatus === ButtonLabel.OUT_OF_STOCK ? (
                <div className={cn(s['stock-type'], s['out-of-stock'])}>
                    <span>{t('Out Of Stock')}</span>
                </div>
            ) : (
                <div className={cn(s['stock-type'], s['in-stock'])}>
                    <span>{t('In Stock')}</span>
                </div>
            )}
        </div>
    )
}
